import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField } from '@mui/material';
import CheckCircleTwoToneIcon from '@material-ui/icons/CheckCircleTwoTone';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchData1, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function CBIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [year, setYear] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory(); // Access the navigation history
    const [isSubmit, setIsSubmit] = useState(false);
    const { isAuthenticated, clubId, branchId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [selectedMembers, setSelectedMembers] = useState({});
    const [type, setType] = useState("1");
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user

            logout();
            return;
        }

        // Token is not expired, fetch data


    }, [isAuthenticated, clubId, branchId, token, logout]);

    const [editableData, setEditableData] = useState(data);

    const handleChange = (event, rowIndex, field) => {
        const newData = [...editableData];
        newData[rowIndex][field] = event.target.value;
        setEditableData(newData);
    }

    const handleChangetype = (event) => {
        setType(event.target.value);
        fetchtableData();
    };

    const [financialyear, setFinancialYear] = useState("");
    const [isReadyToFetch, setIsReadyToFetch] = useState(false);

    const fetchtableData = async () => {
        try {
            const response = await fetchData1('ClubBugetApi', `/${clubId}/${branchId}/${type}/${financialyear}`, token);

            if (response.responseCode === '1111') {
                console.log('Fetched Data:', response);
                setEditableData(response.response_data);
            } else {
                console.warn('Response indicates an issue:', response);
            }
        } catch (error) {
            if (error.response) {
                console.error('Server Error:', error.response.data);
                console.error('Status Code:', error.response.status);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Unexpected Error:', error.message);
            }
        }
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        submitData(e);

    }


    // Submit data function
    const submitData = async (e) => {
        e.preventDefault();

        if (!isSubmit) {
            return;
        }

        // Prepare the data to send (mapping editable data to your model structure)
        const clubbudgetentryslist = editableData.map((clubData) => ({
            Id: clubData.id,
            ClubId: clubId,  // Assuming headId represents ClubId
            BranchId: branchId,  // Assuming branch.id is the BranchId
            FinancialYear: financialyear,  // Assuming financial year is available
            Type: type,  // Assuming type exists in your table data
            IncomeExpenseId: clubData.headId,  // Assuming this field exists
            PreviousEstimate: clubData.previousEstimate,
            CurrentEstimate: clubData.currentEstimate,
            IsActive: true,
            CreatedBy: userId,
            UpdatedBy: userId,
            CreatedDate: new Date(),
            UpdatedDate: new Date()
        }));

        try {
            // Send data to your API
            const response = await postData('ClubBugetApi', clubbudgetentryslist, token);
            console.log('Branch Created success:', response);
            setSuccessMessage("Branch Created successfully!");
            setErrorMessage("");

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            window.location.reload();  // Reload the page after success
        } catch (error) {
            console.error('Branch Create error:', error);
            setErrorMessage("An error occurred while creating the branch.");
        }
    };


    useEffect(() => {
        // Set the current date and initialize financial year
        const currentDate = new Date();
        setYear(currentDate.toISOString().split("T")[0]); // Format as yyyy-MM-dd
        const fy = calculateFinancialYear(currentDate); // Calculate financial year
        setFinancialYear(fy);

        // Set a flag to indicate readiness to fetch data
        setIsReadyToFetch(true);
    }, []);

    // Fetch data only after financial year is set
    useEffect(() => {
        if (isReadyToFetch && financialyear) {
            fetchtableData();
        }
    }, [isReadyToFetch, financialyear, type]);

    // Function to calculate financial year in 21-22 format
    const calculateFinancialYear = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // getMonth() returns 0-based month

        if (month < 7) {
            // Financial year starts from April
            const prevYear = year - 1;
            return `${prevYear.toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
            const nextYear = year + 1;
            return `${year.toString().slice(-2)}-${nextYear.toString().slice(-2)}`;
        }
    };






    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>

                <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    CLUB BUDGET</h6>

            </div>
            {/* <div className="w-full grid grid-cols-6 gap-4 mb-4">

                <div>
                    <label htmlFor="year">To</label>
                    <input
                        className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"

                        value={year}
                        onChange={(e) => {
                            const selectedDate = new Date(e.target.value);
                            setYear(e.target.value);
                            setFinancialYear(calculateFinancialYear(selectedDate));
                        }}
                        type="date"
                        placeholder="Select Date"

                    />
                </div>

                <div>
                    <label htmlFor="financialyear">Financial Year</label>
                    <input
                        className="border-2 border-#234C6A-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"

                        value={financialyear}
                        readOnly
                        type="text"
                        placeholder="Financial Year"
                    />
                </div>
                <div>
                    <label>
                        Select Type<select
                            name="type"
                            value={type}
                            onChange={handleChangetype}
                            className="form-select block w-full mt-1 border-2 border-#234C6A-500"
                        >
                            <option value="1">Expense</option>
                            <option value="2">Income</option>

                        </select>
                    </label>
                </div>

                <div className="flex mt-2">


                    <Button onClick={handleFormSubmit}
                        style={{
                            backgroundColor: '#0e728c',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginLeft: '-50px',
                        }}
                    >
                        <AddIcon style={{ fontWeight: 'bolder' }} /> Save
                    </Button>
                </div>



            </div> */}


            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-4" style={{ marginTop: '-15px' }}>

                <div className="flex flex-col">
                    <label htmlFor="year" className="mb-1">To</label>
                    <input
                        className="border-2 border-[#234C6A] rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        value={year}
                        onChange={(e) => {
                            const selectedDate = new Date(e.target.value);
                            setYear(e.target.value);
                            setFinancialYear(calculateFinancialYear(selectedDate));
                        }}
                        type="date"
                        placeholder="Select Date"
                    />
                </div>

                <div className="flex flex-col">
                    <label htmlFor="financialyear" className="mb-1">Financial Year</label>
                    <input
                        className="border-2 border-[#234C6A] rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:outline-none"
                        value={financialyear}
                        readOnly
                        type="text"
                        placeholder="Financial Year"
                    />
                </div>

                <div className="flex flex-col">
                    <label htmlFor="type" className="mb-1">Select Type</label>
                    <select
                        name="type"
                        value={type}
                        onChange={handleChangetype}
                        className="form-select block w-full border-2 border-[#234C6A] py-2 px-3 rounded text-gray-700"
                    >
                        <option value="1">Expense</option>
                        <option value="2">Income</option>
                    </select>
                </div>

                <div className="flex items-end sm:col-span-2 md:col-span-1 lg:col-span-1">
                    <Button
                        onClick={handleFormSubmit}
                        style={{
                            backgroundColor: '#604652',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '30px',
                        }}
                    >
                        <CheckCircleTwoToneIcon style={{ fontWeight: 'bolder' }} /> Save
                    </Button>
                </div>

            </div>



            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '-15px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Sl No</TableCell>
                                {/*   <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold' }}>Id</TableCell>
                                
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke', fontWeight: 'bold' }}>HeadId</TableCell>*/}
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Expense</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center' }}>Previous Estimate</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center' }}>Previous Actual</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Current Estimate</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center' }}>Current Actual</TableCell>
                                <TableCell sx={{ backgroundColor: '#0c8bce', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Variance</TableCell>


                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}>
                            {editableData.map((clubiedata, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fcff', // Alternate row background colors
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #d2e3eb', fontSize: '14px', padding: '2px' }}>
                                        {index + 1}
                                    </TableCell>

                                    {/* <TableCell sx={{ borderBottom: '1px solid rgb(82, 79, 79)', fontSize: '14px', padding: '2px' }}>
        {clubiedata.id}
      </TableCell> */}
                                    {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>
        {clubiedata.headId}
      </TableCell> */}
                                    <TableCell sx={{ borderBottom: '1px solid #d2e3eb', fontSize: '14px', padding: '2px' }}>
                                        {clubiedata.expense}
                                    </TableCell>


                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px', textAlign: 'center' }}>
                                        {clubiedata.previousEstimate != null ? clubiedata.previousEstimate.toFixed(2) : '-'}
                                    </TableCell>



                                    <TableCell sx={{ borderBottom: '1px solid #d2e3eb', fontSize: '14px', padding: '2px', textAlign: 'center' }}>
                                        {clubiedata.previousActual != null ? clubiedata.previousActual.toFixed(2) : '-'}
                                    </TableCell>

                                    {/* Editable Current Estimate */}
                                    <TableCell sx={{ borderBottom: '1px solid #d2e3eb', fontSize: '14px', padding: '2px' }}>
                                        <TextField
                                            value={clubiedata.currentEstimate != null ? clubiedata.currentEstimate.toFixed(2) : '-'}
                                            onChange={(e) => handleChange(e, index, 'currentEstimate')}
                                            variant="outlined"
                                            size="small"
                                            fullWidth={false}  // Prevents stretching across the entire width
                                            sx={{
                                                width: '150px',
                                                height: '30px',
                                                '& .MuiInputBase-root': {
                                                    height: '30px',
                                                    padding: '0 12px', // Adjust padding to make sure the content fits well
                                                    overflow: 'hidden'  // Prevents any overflow/scroll
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '4px',  // Optional: You can change border radius if needed
                                                }
                                            }}
                                        />
                                    </TableCell>


                                    <TableCell sx={{ borderBottom: '1px solid #d2e3eb', fontSize: '14px', padding: '4px', textAlign: 'center' }}>

                                        {clubiedata.currentActual != null ? clubiedata.currentActual.toFixed(2) : '-'}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #d2e3eb', fontSize: '14px', padding: '4px' }}>

                                        {clubiedata.variance != null ? clubiedata.variance.toFixed(2) : '-'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>




        </div>
    );
}

export default CBIndex;




